/* ¿El furgón tiene puerta?
 *
 * La carga Federico desde `/FurgonesApp`, junto con la lona y el tipo del
 * taller, y hasta ahora **no se veía en ninguna pantalla compartida**: el dato
 * entraba a `furgones.puerta` y ahí se quedaba. Un dato que se carga y nadie
 * ve es un dato que se deja de cargar.
 *
 * Es la lona con otra etiqueta: la LECTURA la hace `tresEstados` —una sola,
 * para que el string `"false"` no lo entienda una columna y la otra no— y acá
 * viven nada más que las palabras.
 *
 * «Sin dato» no se dice como «No tiene»: nace con 678 de 679 sin cargar, y
 * dibujarlos como furgones sin puerta declararía algo que nadie miró.
 */

import { tresEstados, SI, NO, SIN_DATO } from "./tresEstados";

export { SIN_DATO };

export const ESTADOS = [
  { clave: SI, etiqueta: "Tiene" },
  { clave: NO, etiqueta: "No tiene" },
  { clave: SIN_DATO, etiqueta: "Sin dato" },
];

export const estadoPuerta = tresEstados;

export function etiquetaPuerta(valor) {
  const e = ESTADOS.find((x) => x.clave === tresEstados(valor));
  return e ? e.etiqueta : "Sin dato";
}
